import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-modal";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import MealsStructure from "../../diet/meal/MealsStructure";
import CommonStatCard from "./CommonStatCard";
import {
  getCardIcon,
  getCardLabel,
  getCardValue,
  getModCardLabel,
} from "../../common-data/Conversions";
import { fetchAllPTSalesStatsData } from "../../../redux/reducers/apiSlice";
import PTFlowStatCardDetails from "./PTFlowStatCardDetails";
import { convertThenFormat } from "../../common-data/Converts";
// import RevenueDetails from "./revenue-detail/RevenueDetails";

const PT_REV_INFO_ORDER = [
  "total_sales",
  "full_payment_received",
  "partial_payment_received",
  "partial_payment_pending",
];

const EXCLUDED_KEYS = [
  "full_received_count",
  "partial_received_count",
  "partial_pending_count",
  "carry_over_received_count",
  "carry_over_pending_count",
  "total_sales_count",
];

const PTRevenueInfoStats = ({
  userInfoData,
  prevAllFilters = {},
  prevFilters = {},
}) => {
  const dispatch = useDispatch();
  const { allPTStatsSalesLoading, allPTStatsSales } = useSelector(
    (state) => state.api
  );

  const initialPtStatsData = {
    allData: null,
    todaySaleStats: null,
  };
  const [allPTDatas, setAllPTDatas] = useState(initialPtStatsData);
  const iniModValues = {
    isModOpen: false,
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  const onClickStatCard = (name) => {
    setModValues((prevs) => ({
      ...prevs,
      isModOpen: true,
      modName: name,
    }));
  };

  function getPTRevenueStats(prevFilters) {
    dispatch(
      fetchAllPTSalesStatsData({
        filters: prevFilters,
        token: userInfoData?.token,
      })
    );
  }

  const sortedCards =
    allPTDatas.allData &&
    Object?.entries(allPTDatas.allData)
      ?.sort(([keyA], [keyB]) => {
        const indexA = PT_REV_INFO_ORDER.indexOf(keyA);
        const indexB = PT_REV_INFO_ORDER.indexOf(keyB);

        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      })
      ?.map(([key, value], index) => {
        const totalRevenueCount = allPTDatas.allData?.total_sales_count || 0;
        const fullReceivedCount = allPTDatas.allData?.full_received_count || 0;
        const partialReceivedCount =
          allPTDatas.allData?.partial_received_count || 0;
        const partialPendingCount =
          allPTDatas.allData?.partial_pending_count || 0;
        const partialPastReceivedCount =
          allPTDatas.allData?.carry_over_received_count || 0;
        const partialPastPendingCount =
          allPTDatas.allData?.carry_over_pending_count || 0;

        return (
          <React.Fragment key={index}>
            {!EXCLUDED_KEYS.includes(key) && (
              <CommonStatCard
                tagName={key}
                cardLabel={
                  <>
                    {getCardLabel(key)}(
                    <b>
                      {key === "total_sales"
                        ? totalRevenueCount
                        : key === "full_payment_received"
                        ? fullReceivedCount
                        : key === "partial_payment_received"
                        ? partialReceivedCount
                        : key === "partial_payment_pending"
                        ? partialPendingCount
                        : key === "carry_over_partial_received"
                        ? partialPastReceivedCount
                        : key === "carry_over_partial_pending"
                        ? partialPastPendingCount
                        : 0}{" "}
                      Members
                    </b>
                    )
                  </>
                }
                value={getCardValue(key, value || 0)}
                icon={getCardIcon("_", allPTStatsSalesLoading)}
                onClickCard={key !== "total_sales" && onClickStatCard}
              />
            )}
          </React.Fragment>
        );
      });

  useEffect(() => {
    getPTRevenueStats(prevFilters);
  }, [prevFilters]);

  useEffect(() => {
    setAllPTDatas((prevState) => {
      const newState = { ...prevState };

      if (allPTStatsSales?.status) {
        newState.allData =
          allPTStatsSales?.sales_stats?.length > 0
            ? allPTStatsSales.sales_stats[0]
            : null;
        newState.todaySaleStats =
          allPTStatsSales?.sales_stats_today?.length > 0
            ? allPTStatsSales.sales_stats_today[0]
            : null;
      } else {
        newState.allData = null;
        newState.todaySaleStats = null;
      }

      return newState;
    });
  }, [allPTStatsSales]);

  return (
    <div className="flexCol">
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          {/* {modValues.modName !== "total_sales_today" && ( */}
            <ModalHeadAndClose
              title={`${
                modValues.modName === "partial_payment_received" ||
                modValues.modName === "partial_payment_pending" ||
                modValues.modName === "total_sales_today"
                  ? getModCardLabel(modValues.modName)
                  : getCardLabel(modValues.modName)
              }`}
              onClose={onCloseModal}
            />
          {/* )} */}

          {
            // modValues.modName === "total_sales_today" ? (
            //   <RevenueDetails
            //     userInfoData={userInfoData}
            //     prevAllFilters={prevAllFilters}
            //     onClose={onCloseModal}
            //   />
            // ) :
            <PTFlowStatCardDetails
              userInfoData={userInfoData}
              clickedCard={modValues.modName}
              prevAllFilters={prevAllFilters}
            />
          }
        </div>
      </Modal>

      <MealsStructure
        text={"PT Revenue info"}
        isReload={() => getPTRevenueStats(prevFilters)}
      />

      <div className="cards-container cards-grid-container grid-5 pt-flow-new">
        <CommonStatCard
          tagName={"total_sales_today"}
          cardLabel={
            <>
              total PT sale today (
              <b>
                {allPTDatas?.todaySaleStats?.total_sales_count || 0} Members
              </b>
              )
            </>
          }
          value={`₹${convertThenFormat(
            allPTDatas?.todaySaleStats?.total_sales || 0
          )}`}
          icon={getCardIcon("_", allPTStatsSalesLoading)}
          onClickCard={onClickStatCard}
        />

        {sortedCards}
      </div>
    </div>
  );
};

export default PTRevenueInfoStats;
